import { Trans } from "@lingui/react/macro";
import { Text } from "@offstreetparking/design-system/typography";
import {
	stashPendingCheckout,
	usePermitEntrySelection,
	usePermitFormData,
} from "@offstreetparking/portal-flow/components/CreatePermitWizard/PermitContextProvider";
import {
	type PendingSavedPermit,
	stashPendingSavedPermit,
} from "@offstreetparking/portal-flow/components/CreatePermitWizard/hooks/useSavedPermits";
import { PaymentErrorAlert } from "@offstreetparking/portal-flow/components/forms/Alert";
import { useKiosk } from "~/components/providers/KioskProvider";
import type { RouterOutputs } from "~/services/offstreetApi/types";

type TouchNetFormProps = {
	paymentSession: NonNullable<RouterOutputs["paymentSession"]["createPaymentSessionPublic"]["session"]>;
	formId: string;
	setIsProcessing: (isProcessing: boolean) => void;
	pendingSavedPermit?: PendingSavedPermit;
};

export const TouchNetForm = ({ paymentSession, formId, setIsProcessing, pendingSavedPermit }: TouchNetFormProps) => {
	const touchNet = paymentSession.client?.touchnet;
	const formData = usePermitFormData();
	const entrySelection = usePermitEntrySelection();
	const { isKiosk } = useKiosk();

	if (!paymentSession.clientSecret || !touchNet) {
		return <PaymentErrorAlert />;
	}

	return (
		<form
			id={formId}
			method="POST"
			action={touchNet.upaySiteUrl}
			className="space-y-4"
			onSubmit={() => {
				if (pendingSavedPermit) {
					stashPendingSavedPermit(pendingSavedPermit);
				}
				if (!isKiosk) {
					stashPendingCheckout({ formData, entrySelection });
				}
				setIsProcessing(true);
			}}
		>
			<input type="hidden" name="TICKET" value={paymentSession.clientSecret} />
			<input type="hidden" name="TICKET_NAME" value={paymentSession.paymentId} />
			<input type="hidden" name="UPAY_SITE_ID" value={touchNet.upaySiteId} />
			<Text>
				<Trans>You’ll continue to your institution’s secure payment page to complete your payment.</Trans>
			</Text>
		</form>
	);
};
